<template>
    <v-container class="max-container">
        <v-row class="warning-box" v-if="hasShopAddress">
            <p>
                Cada recompensa e oferta pode ser resgatada <span class="text-bold"> apenas em lojas específicas </span>. Verifique na página de cada oferta e recompensa as lojas participantes.
                <br/>
                <span class="text-bold"> Esta lista pode estar desatualizada! </span>. Para confirmar, entre em contato com a loja por telefone para garantir que ela está participando do programa.
            </p>
        </v-row>

        <div class="margin-top-divider-30" v-if="hasShopAddress" />

        <v-row class="address__row" v-if="hasShopAddress">
            <v-col xs="12" sm="12" md="4" lg="4">
                <h1> Encontre-nos </h1>
                <div class="address-container" >
                    <div class="address">
                        <v-list>
                          <v-list-group
                            v-for="item in adressesList"
                            :key="item.title"
                            v-model="item.active"
                            :color="currentCompany.buttonsColor"
                            :prepend-icon="item.icon"
                            :style="`color: ${currentCompany.buttonsColor}`"
                            no-action
                            @click="setMarkerLocation(item.address)"
                          >
                            <template v-slot:activator>
                              <v-list-item-content>
                                <h4>
                                  {{item.title}}
                                </h4>
                              </v-list-item-content>
                            </template>
                    
                            <v-list-item
                              v-for="child in item.items"
                              :key="child.title" 
                              style="padding-left: 16px"
                              @click="goListItem(child.id, item)"
                            >
                              <v-list-item-icon >
                                <v-icon :color="currentCompany.buttonsColor"> {{child.icon}} </v-icon>
                              </v-list-item-icon>
                              
                              <v-list-item-content>
                                {{child.text}}
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-group>
                        </v-list>
                    </div>
                </div>
            </v-col>

            <v-col xs="12" sm="12" md="8" lg="8" class="container-map" :class="mobileControl? 'container-map--mobile':''" v-if="hasShopAddress">
                <GmapMap :center="center" :zoom="15" map-type-id="terrain" class="map">
                    <GmapMarker :clickable="true" :draggable="true" :position="marker" @click="center = marker"/>
                </GmapMap>
            </v-col>
        </v-row>

        <v-row v-if="!hasShopAddress" class="flex-col-center w-100">
            <h3 style="text-align: center;"> Não temos nenhuma loja cadastrada por enquanto... </h3>

            <v-img :max-width="dynamicWidthImg" class="empty--img" src="@/assets/emptyView-shopAddress.svg" />
        </v-row>
    </v-container>
</template>

<script>
// Functions
import {formatTelephoneForFront, removeMaskOfTelephone} from "@/support/functions/telephone.functions"

//Store
import { mapGetters, mapActions } from "vuex";

//Service
import { getContactInfoById } from "./service/shop-address.service";

export default {
    name: 'Shop-address',
    computed: {
      ...mapGetters('authenticateStore', {
          currentCompany: 'get_currentCompany'
        }
      ),
      adressesList() {
        var newList = []
        this.addressArr.forEach( (item, index) => {
          newList.push({
            title: item.name ? item.name : 'Não informado',
            address: item.address,
            active: index ==0,
            icon: 'mdi-store',
            items: [
              {id: 1, text: this.addressDescription(item.address), icon: 'mdi-map-marker',},
              {id: 2, text: item.telephone ? formatTelephoneForFront(item.telephone) : '-', icon: 'mdi-phone'},
              {id: 3, text: item.email ? item.email : '-', icon: 'mdi-email-outline'}
            ]
          })
        })
        return newList;
      }
    },
    data: () => ({
        center: {
            lat: null,
            lng: null
        },
        addressArr: [],
        marker: {
            lat: null,
            lng: null
        },
        mobileControl: false,
        dynamicWidthImg: '60%',
        hasShopAddress: false,
    }),
    created() {
        this.compareWidth()
        window.addEventListener("resize", this.compareWidth);
        this.getAllScreenInfo()
    },
    methods: {
        ...mapActions('shopAddressLoaderStore', ['SET_CONTACTINFO_STATE']),
        getAllScreenInfo() {
            getContactInfoById( this.currentCompany.id )
                .then( success => {
                        if( success.data.results ) {
                            this.addressArr = success.data.results
                            this.setMarkerLocation(this.addressArr[0].address)
                            this.hasShopAddress = true
                            setTimeout(() => {
                                this.SET_CONTACTINFO_STATE(true)
                            }, 300);
                        
                        } else this.SET_CONTACTINFO_STATE(true)

                    }
                )
                .catch( error => {
                        this.hasShopAddress = false
                        this.SET_CONTACTINFO_STATE(true)

                        if( error != null ) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        compareWidth() {
            if( window.innerWidth < 600 ) {
                this.mobileControl = true

            } else {
                this.mobileControl = false
            }
            
            ( window.innerWidth < 640)? this.dynamicWidthImg = '80%' : this.dynamicWidthImg = '60%';
        },
        setMarkerLocation( address ) {
            this.center.lat = address.latitude
            this.center.lng = address.longitude

            this.marker.lat = address.latitude
            this.marker.lng = address.longitude
        },
        goToGoogleMaps( url ) {
          const link = `https://www.google.com.br/maps/search/${url}`
          window.open(link, '_blank');
        },
        goToTelephone( telephone ) {
            const link = `tel:${telephone}`
            window.open(link, '_blank');
        },
        goToEmail( email ) {
            const link = `mailto:${email}`
            window.open(link, '_blank');
        },
        addressDescription(address) {
          return `${address.street}, ${address.number ? address.number + ',' : ''} ${address.neighborhood}, ${address.cityName} - ${address.stateCode}`
        },
        goListItem(idItem, item) {
          switch (idItem) {
            case 1: {
              this.goToGoogleMaps( item.items[0].text)
              break;
            }

            case 2: {
              if(item.items[1].text !== '-') {
               this.goToTelephone(removeMaskOfTelephone(item.items[1].text))
              }
              break;
            }

            case 3: {
              if(item.items[2].text !== '-') {
               this.goToEmail(item.items[2].text)
              }
              break;
            }  
          
            default:
              break;
          }
        }
    }
}
</script>

<style scoped>
h3 {
    margin-left: 12px;
}
.address {
    max-height: 454px;
    overflow: auto;
}
.warning-box {
    border: 1px solid var(--cor--preta);
    border-radius: 14px !important;
    display: flex;
    flex: auto !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 20px;
}
@media(max-width: 600px) {
    .address__row{
        flex-direction: column !important;
    }
}
@media(max-width: 960px) {
    .container-map{
        height: 300px !important;
    }    
}
.address__text:hover{
    text-shadow: 0px 1px 3px var(--cor--preta);
}
.map {
    width: 100%; 
    height: 100%;
    max-height: 500px;
    min-height: 300px;
}
.container-map {
    display: flex;
    flex: auto !important;

    justify-content: center;
    align-items: center;
}
.container-map--mobile {
    height: 350px;
}
.empty--img {
    margin-top: 24px;
    margin-bottom: 10px;
}
</style>